import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';
import { getCallableMessage, unwrapCallableData } from './callableResponse';

interface GenerateBrandKeywordResearchRequest {
  companyId: string;
  brandKey: string;
  categoryKey: string;
  marketplace: string;
  language: string;
}

interface GenerateBrandKeywordResearchResponse {
  companyId: string;
  jobId: string;
  researchId: string;
}

interface GenerateBrandKeywordResearchForAllRequest {
  companyId: string;
}

interface GenerateBrandKeywordResearchForAllResponse {
  companyId: string;
  jobId?: string;
  scheduledCount: number;
  requestedCount?: number;
  skippedCount?: number;
  jobCreated?: boolean;
  message?: string;
}

interface DeleteBrandKeywordResearchRequest {
  companyId: string;
  researchId: string;
}

interface DeleteBrandKeywordResearchResponse {
  companyId: string;
  researchId: string;
  deleted: boolean;
}

const generateBrandKeywordResearch = async (
  payload: GenerateBrandKeywordResearchRequest,
): Promise<GenerateBrandKeywordResearchResponse> => {
  const fn = httpsCallable<
    GenerateBrandKeywordResearchRequest,
    GenerateBrandKeywordResearchResponse
  >(functions, 'handle_generate_brand_keyword_research');

  const result = await fn(payload);
  return unwrapCallableData<GenerateBrandKeywordResearchResponse>(result.data);
};

const generateBrandKeywordResearchForAll = async (
  companyId: string,
): Promise<GenerateBrandKeywordResearchForAllResponse> => {
  const fn = httpsCallable<
    GenerateBrandKeywordResearchForAllRequest,
    GenerateBrandKeywordResearchForAllResponse
  >(functions, 'handle_generate_brand_keyword_research_for_all');

  const result = await fn({ companyId });
  return {
    ...unwrapCallableData<GenerateBrandKeywordResearchForAllResponse>(result.data),
    message: getCallableMessage(result.data),
  };
};

const deleteBrandKeywordResearch = async (
  payload: DeleteBrandKeywordResearchRequest,
): Promise<DeleteBrandKeywordResearchResponse> => {
  const fn = httpsCallable<
    DeleteBrandKeywordResearchRequest,
    DeleteBrandKeywordResearchResponse
  >(functions, 'handle_delete_brand_keyword_research');

  const result = await fn(payload);
  return unwrapCallableData<DeleteBrandKeywordResearchResponse>(result.data);
};

export {
  deleteBrandKeywordResearch,
  generateBrandKeywordResearch,
  generateBrandKeywordResearchForAll,
};
